module.exports = __webpack_public_path__ + "static/BrandonGrotesque-ExtraBold-cf1af9e7a91331fe28882085498974c1.woff2";